import { Store } from '@/types/vuex/store';
import { MutationTypes } from '@/store/mutations';

export class WindowWatcher {
    private store;

    constructor (store: Store) {
        this.store = store;
    }

    public attachListener () {
        window.addEventListener('resize', this.watch.bind(this));
    }

    public detachListener () {
        window.removeEventListener('resize', this.watch.bind(this));
    }

    public watch () {
        const width = WindowWatcher.getWidth();
        if (width <= 759 && !this.store.state.isMobile) {
            this.store.commit(MutationTypes.SetIsMobile, true);
        } else if (width > 759 && this.store.state.isMobile) {
            this.store.commit(MutationTypes.SetIsMobile, false);
        }
    }

    private static getWidth (): number {
        return Math.max(document.documentElement.clientWidth, window.innerWidth);
    }
}
